<!-- HomeHistory.vue -->
<template>
<!--
<div class="debugOutline2" >
-->
<div class="" >

<h3>Crawling Log for {{selectedDate2}} last 60 minutes</h3>
<div v-html="selectedDateCrawl60" class='tBlue tSmall' v-if="$vuetify.breakpoint.xs"
></div>
<div v-html="selectedDateCrawl60" class='tBlue' v-else-if="$vuetify.breakpoint.sm"></div>
<div v-html="selectedDateCrawl60" class='tBlue tLarger' v-else></div>
<br>

<!--
<div sticky-container>
  <div v-sticky sticky-offset="offset" sticky-side="top" class="sticky">
    -->
    <h3>History for {{selectedDate2}} ( {{tF}} - {{tF2}} ) {{coursesStringAbbreviated}}</h3>
<!--
  </div>
  -->
                                                <!-- {{selectedCourses}} 
                                                tF={{tF}} {{tF2}}
                                                -->
<ul>
    <li v-for="(value, c, index) in selectedDateHistory"
        :key=index
        >
        <div v-if="selectedCourses.indexOf(c)>=0">
        <h4>  {{ c }}  </h4>
            <ul>
                <li v-for="(value, t, index) in selectedDateHistory[c]"
                        :key=index
                        >
                    <div v-if="isTimeSelected(t, tF, tF2)">
                    {{ t }}   
                    <ul>
                        <li v-for="(value, h, index) in selectedDateHistory[c][t]"
                            :key=index
                            >
                            <b>{{ h }}</b>  <span class='tSmaller tBlue'> has {{objLen(selectedDateHistory[c][t][h])}} changes:</span>
                            <ul>
                                <li v-for="(value, v, index) in selectedDateHistory[c][t][h]"
                                    :key=index
                                    class='noBullet'
                                    v-bind:class="classObject(value)"  
                                    >
                                                                        <!--
                                                                        {{ value}}
                                                                        -->
                                    <!-- a booking -->
                                    <span v-if="value.players>0 && value.playersPrior==0"
                                      class='tHotPink'>
                                        players: {{ value.playersPrior }} => {{ value.players }}
                                        {{ shortTimestamp(value.tstamp) }}   
                                        {{ value.row.captain }}   
                                    </span>

                                    <!-- a change -->
                                    <span v-else-if="value.players>0 && value.playersPrior>0"
                                      class='tSmall'>
                                        players: {{ value.playersPrior }} => {{ value.players }}
                                        {{ shortTimestamp(value.tstamp) }}   
                                        {{ value.row.captain }}   
                                    </span>

                                    <!-- a cancellation -->
                                    <span v-else
                                      class=' tGreen'>
                                        Players: {{ value.playersPrior }} => {{ value.players }}
                                        {{ shortTimestamp(value.tstamp) }}   
                                        <span class='tSmaller tGray'> (was booked by {{ value.rowPrior.captain }})</span>  
                                    </span>
                                </li>
                            </ul>

                        </li>
                    </ul>

                  </div>
                </li>
            </ul>

      </div>
    </li>
</ul>
<!--
</div>
-->
<br>



<h3>Crawling Log Detail (last 100)

  <v-btn x-small 
    class="ml-2"
    @click="toggleCrawlLog(10)"  
    >
    10 mins
  </v-btn>

  <v-btn x-small 
    class="ml-2"
    @click="toggleCrawlLog(60)"  
    >
    60 mins
  </v-btn>

  <v-btn x-small 
    class="ml-2"
    @click="toggleCrawlLog(240)"  
    >
    4 hrs
  </v-btn>

  <!--
  <v-btn x-small 
    class="ml-2"
    @click="toggleCrawlLog(1440)"  
    >
    24 hrs
  </v-btn>
  -->

    <v-btn x-small 
    class="ml-2"
    @click="toggleCrawlLog(0)"  
    v-if="showCrawlLog"
    >
    hide
  </v-btn>

</h3> 

    <v-layout v-if="showCrawlLog" class='tBlue'>

      <v-flex xs6 sm5 md3 pl-6>
      <b>Tee Sheet Date </b>
      </v-flex>
      <v-flex xs5 sm3 md2 ml-4 pl-6>
        <b>Crawled @ </b>                                   
      </v-flex>
      <v-flex xs1 md1 ml-0 class='tR'>
        <b>Secs</b>
      </v-flex>
      <v-flex xs2 md2 ml-2 v-if="$vuetify.breakpoint.mdAndUp" class="text-left">
        <b>Member</b>
      </v-flex>

    </v-layout>

    <ul v-if="showCrawlLog">
        <li v-for="(value, v, index) in selectedDateSniffHistory"
                :key=index
                class='noBullet'
                >
          <v-layout>
            <v-flex xs6 sm5 md3>
            {{value.teeSheetDate}} 
            </v-flex>
            <v-flex xs5 sm3 md2 pl-2>
            {{shortTimestamp(value.tstamp,false)}}
            </v-flex>
            <v-flex xs1 md1 class='tR'>
            {{value.refreshSecs}}{{value.secs}}
            </v-flex>
            <v-flex xs2 md2 ml-3 class='text-left' v-if="$vuetify.breakpoint.mdAndUp">
            {{value.member}}
            </v-flex>
          </v-layout>
        </li>
    </ul>

<!--
{{$store.state.sniffHistoryArr}}
-->



  <!-- table version, deprecated
    <div v-if="showCrawlLog" >
        <tr class='tBlue'>
          <td>
          <b>Tee Sheet Date </b>
          </td>
          <td>
          <b>Crawled @ </b>                                   
          </td>
          <td>
          <b>Seconds</b>
          </td>
        </tr>
        <tr v-for="(value, v, index) in selectedDateSniffHistory"
                :key=index
                class='noBullet'
                >
            <td>
            {{value.teeSheetDate}} 
            </td>
            <td class='tRed'>
            {{shortTimestamp(value.tstamp,false)}}
            </td>
            <td class='tR'>
            {{value.refreshSecs}}
            </td>
        </tr>
    </div>
  -->

<!--
{{$store.state.sniffHistoryArr}}
{{selectedDateSniffHistory}}
{{$store.state.history}}
-->
 
</div>
</template>

<script>

// includes chelseaDateToYYYY_MM_DD()
import { exampleMixin } from '../mixins/exampleMixin.js'   // eslint-disable-line no-unused-vars

export default {

    mixins: [exampleMixin],

    //el: '#intro',

    data() {
        return {
            showCrawlLog: false,
            showCrawlLogMins: 60,
            timeNow: -1,
            offset: {
              bottom: false,
              top: 100,
              sticked: true
            }
        }
    },

    props: {
        selectedDate2: String,
        selectedCourses: Array,
        tF: Number,
        tF2: Number
    },

    computed: {

      selectedDateHistory () {
        let dd = "d"+this.selectedDate2
        let x = this.$store.state.history[dd]
        // filter out if not in the selectedCourses array
        return x
      },

      // sniff history from the last hour
      selectedDateSniffHistory () {
        //let d = this.selectedDate2
        let x = this.$store.state.sniffHistoryArr
          //console.log("selectedDateSniffHistory",x)
        const now = this.getMsec()
        const oldest = this.showCrawlLogMins*60000
        let res = []
        for (let i=0;i<x.length;i++) {
          //console.log("selectedDateSniffHistory",key,value.timestamp)
          if (now-x[i].timestamp < oldest)
          res.push(x[i])
        }
        return res
/*
*/
      },

      selectedDateCrawl60header () {
        return "now " //      -->        earlier"
      },
      selectedDateCrawl60 () {
        const now = this.getMsec();
        let d = this.selectedDate2  // YYYYMMDD selected
        d = d.trim()
        const dd = d.substring(6,8)   // DD
        let x = this.$store.state.sniffHistoryArr
        let r = ""
        let arr = []
        arr.length = 60
        arr.fill("_")
        let dT = 0
        let commaPos = 0
        let sniffDD = ""

        for (let [key, value] of Object.entries(x)) {
                        //console.log(`${key}: ${value}`);
                        //console.log(value.teeSheetDate);
                        //console.log(value);
          if (now - value.timestamp < 3600000) {
              commaPos = value.teeSheetDate.indexOf(",")
              sniffDD = value.teeSheetDate.substring(commaPos-2,commaPos)
                      //console.log(dd,sniffDD,dd+sniffDD);
              if (sniffDD == dd) {
                  dT = Math.floor((now - value.timestamp)/60000)
                  //arr[dT] = "&diams;"   // doesn't work
                  //arr[dT] = "&#9609;"
                  //arr[dT] = "X"
                  //arr[dT] = "&block;"   // doesn't work
                  /*
                  arr[dT] = "&#9724;"     // square 
                  arr[dT] = "&#9971;"     // golf tee
                  arr[dT] = "&#10175;"    // eyes
                  arr[dT] = "&#128126;"   // purple alien
                  arr[dT] = "&#129408;"   // crab
                  arr[dT] = "&#128030;"   // ladybug
                  */
                  arr[dT] = "&#128375;"   // spider
              }
              else {
                r = r + key
              }
          }
        }

        let str = "<span class='tSmaller'>now:</span>"
        for (let j=0;j<60;j++) {
          //if (j%10==9) str += "<b>" // bold every 10th
          str += arr[j]
          //if (j%10==9) str += "</b>"
        }
        //str += "<span class='tSmaller'> hour ago</span>"
        return str
      },

      coursesStringAbbreviated () {
        const x = this.selectedCourses
        if (x.length==0) return ""
        if (x.length==1) return x[0]
        let s = "";
        for (let i=0;i<x.length;i++) {
          s += x[i].substring(0,3);
          if (i<x.length-1) s += " "
        }
        return s
      }
    },

    watch: {

      sniffFromStore: function () {
        if (this.$store.state.sniffing!=undefined) {
          const d = this.$store.state.sniffing.sniffed
          this.sniffDT = new Date(d)
        }
        else this.sniffDT =  ""
      },
    },

    methods: {

        toggleCrawlLog (minutes) {
          if (minutes) {
            this.showCrawlLog = true
            this.showCrawlLogMins = minutes
          }
          else {
            this.showCrawlLog = false;
          }
          return
        },

        // number of properties in an object
        objLen (obj) {
            return Object.keys(obj).length
        },

        // Sat Feb 29 2020 22:49:54 GMT-0700 (Mountain Standard Time) => Sat Feb 29 22:49
        shortTimestamp (timestamp,showSeconds) {
          let ll = 21
          if (showSeconds) ll = 24
            return timestamp.substring(0,10)+timestamp.substring(15,ll)
        },

        classObject: function (value) {
              //console.log("classObject",course)
          if (value===undefined) return ""
          //if (item.diff=='+')
          let s = "tLightGray"
          if (value.cancellation) s = "cancellation"
          return s
        },

      shortenDate (d) {
          // February 11, 2020 - Tuesday   ==> Feb 11 - Tue
          const i = d.indexOf(" ")
          const j = d.indexOf("-")

          let s = ""
          s += d.substring(0,3)+d.substring(i,i+3)
          s += d.substring(j-1,j+5)
          return s
      },

      getCorrectString (dateTimeString,includeYear) {
          var a  = new Date(dateTimeString);
          let s = ('00'+(a.getMonth()+1)).substring(('00'+(a.getMonth()+1)).length-2) +'/'
              +('00'+a.getDate()).substring(('00'+a.getDate()).length-2)+' ';
          if (includeYear) s += '/'+a.getFullYear()+' ';
          s += ('00'+a.getHours()).substring(('00'+a.getHours()).length-2)+':'
              +('00'+a.getMinutes()).substring(('00'+a.getMinutes()).length-2)+':'
              +('00'+a.getSeconds()).substring(('00'+a.getSeconds()).length-2);
          return s;
      },

      getMsec: function() {
          const d = new Date();
          return d.getTime()
      },

      getNow: function() {
          const today = new Date();
          let mStr = String(today.getMonth()+1);
          if (mStr.length<2) mStr = "0"+mStr;
          let dStr = String(today.getDate()+1);
          if (dStr.length<2) dStr = "0"+dStr;
          let date = today.getFullYear()+'-'+ mStr +'-' + dStr;

          let hrsStr = String(today.getHours());
          if (hrsStr.length<2) hrsStr = "0"+hrsStr;
          let minStr = String(today.getMinutes());
          if (minStr.length<2) minStr = "0"+minStr;
          let secStr = String(today.getSeconds());
          if (secStr.length<2) secStr = "0"+secStr;
          const time = hrsStr + ":" + minStr + ":" + secStr;
          //const dateTime = date +' '+ time;
          if (this.nowTimeOnly) {
            this.timestampRT = time;
          }
          else {
            this.timestampRT = date +' '+ time;
          }
      },

      classHourglass: function () {
        const lastLook = this.$store.state.teeSheets[this.selectedNode].stats.timestamp
        const d = new Date();
        const secondsSinceLastLook = (d.getTime() - lastLook)/1000
            //console.log("secondsSinceLastLook",secondsSinceLastLook)

        const cycleSeconds = 6 * this.$store.state.sniffing.refreshSeconds

        let s = "";
        if (secondsSinceLastLook>cycleSeconds-10) {
          s = "red--text"
        }
        else if (secondsSinceLastLook>.75*cycleSeconds) {
          s = "orange--text"
        }
        else if (secondsSinceLastLook>.5*cycleSeconds) {
          s = "purple--text"
        }
        else if (secondsSinceLastLook>.25*cycleSeconds) {
          s = "blue--text"
        }
        return s
      },


      isTimeSelected(tt, tF, tF2) {
        tt = Number(tt);  // make sure this is a number
        if (tF2==0) {
            return (tt==tF)   // simple comparison of exact time
        }
        // 2nd time is specfied, so treat the times as a range
        else {
            if (tt<tF) return false;    // too early
            if (tt>tF2) return false;   // too late
            return true;
        }
      }

    },

    // https://stackoverflow.com/questions/57249466/getting-current-time-and-date-in-vue-js
    created() {
        setInterval(this.getNow, 1000);
    },

}

/*
//
// true if   tF <= tt <= tF2
//
function isTimeSelected(tt, tF, tF2) { 
        //console.log("isTime",tt,tF,tF2)
    tt = Number(tt);  // make sure this is a number
    if (tF2==0) {
        return (tt==tF)   // simple comparison of exact time
    }
    // 2nd time is specfied, so treat the times as a range
    else {
        if (tt<tF) return false;    // too early
        if (tt>tF2) return false;   // too late
        return true;
    }
}
*/


</script>

<style scoped>

.noBullet {
    list-style-type: none;
}

.cancellation {
  background-color: yellow;
  color: red;
}

/* doesn't work here */
.stickyXX {
	background-color: #aaffff;
	position: -webkit-sticky;
	position: sticky;
	top: 0;
}

  .tLarger {
    font-size: 150%;
  }
  .tLarger2 {
    font-size: 200%;
  }
  .tPink {
    color: pink;
  }
  .tHotPink {
    color: hotpink;
  }

/* trying
https://www.npmjs.com/package/vue-sticky-directive
https://www.vuescript.com/powerful-sticky-directive-for-vue/

but doesn't work.  possibly because of the app bar at the top

also 
https://github.com/ianaya89/vue-sticky-js
https://renatodeleao.github.io/vue-sticky-directive/




*/


</style>